<template>
  <button
    :disabled="loading"
    v-bind="$attrs"
    v-on="$listeners"
    class="flex items-center">
    <div v-if="loading" class="btn-spinner mr-2" />
    <slot />
  </button>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    loading: Boolean,
  },
}
</script>
